import React from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';

const IconSpan = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  background: ${p => p.match ? '#2ECC71' : '#E74C3C'};
`;

const MatchIndicator = ({ match, lang = 'en' }) => {
  const t = useLocale(lang, 'comparison');
  const label = match ? (t.match?.yes || 'Names match') : (t.match?.no || 'Names differ');

  return (
    <IconSpan match={match} role="img" aria-label={label}>
      {match ? '\u2713' : '\u2715'}
    </IconSpan>
  );
};

export default MatchIndicator;
